import { useState, useEffect } from 'react';

/**
 * Countdown to a timestamp — ticks every second.
 * Returns { days, hours, mins, secs }, all zero once the target passes.
 */
export function useCountdown(endsAt) {
  const [parts, setParts] = useState({ days: 0, hours: 0, mins: 0, secs: 0 });

  useEffect(() => {
    if (!endsAt) return;

    const update = () => {
      const diff = new Date(endsAt) - Date.now();
      if (diff <= 0) {
        setParts({ days: 0, hours: 0, mins: 0, secs: 0 });
        return;
      }
      const totalSecs = Math.floor(diff / 1000);
      setParts({
        days: Math.floor(totalSecs / 86400),
        hours: Math.floor((totalSecs % 86400) / 3600),
        mins: Math.floor((totalSecs % 3600) / 60),
        secs: totalSecs % 60,
      });
    };

    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
  }, [endsAt]);

  return parts;
}
